module.exports = __webpack_public_path__ + "static/review-flow-80-7de0fc6d7cb1c9b46b0ff26cea363fa2.jpg";